module.exports = __webpack_public_path__ + "img/logo-rd.6d402dcf.svg";